export const femtasyIconNames = [
  '15sec-bckwrds',
  '15sec-frwrds',
  'Add-to-queue',
  'Adjustsettingsline',
  'Adjustsettingssolid',
  'Alarmline',
  'Alarmsolid',
  'Arrowdown',
  'Arrowleft',
  'Arrowright',
  'Arrowup',
  'Audiofolderline',
  'Audiofoldersolid',
  'Backwardsline',
  'Backwardssolid',
  'Bankcardline',
  'Bankcardsolid',
  'Bellline',
  'Belloffline',
  'Bellsolid',
  'Bluetoothline',
  'Bluetoothsolid',
  'Calendarline',
  'Calendarsolid',
  'Cameraline',
  'Camerasolid',
  'Cancel',
  'Check',
  'Checkboxfilled',
  'Checkboxline',
  'Checkcircleline',
  'Checkcirclesolid',
  'Clockline',
  'Clocksolid',
  'Copied',
  'Copy',
  'Discountline',
  'Discountsolid',
  'Edit-pen',
  'Exclamationline',
  'Exclamationsolid',
  'Exportline',
  'Eyeline',
  'Eyesolid',
  'Eyeoffline',
  'Facebookline',
  'Facebooksolid',
  'Figmaline',
  'Figmasolid',
  'Filterline',
  'Filtersolid',
  'Followspeaker',
  'Forwardsline',
  'Forwardssolid',
  'Globeline',
  'Globesolid',
  'Hamburger',
  'Heartline',
  'Heartsolid',
  'Homeline',
  'Homesolid',
  'Importline',
  'Infoline',
  'Infosolid',
  'Instagramline',
  'Instagramsolid',
  'LinkedInline',
  'LinkedInsolid',
  'Lockline',
  'Locksolid',
  'Loginline',
  'Logoutline',
  'Mailline',
  'Mailsolid',
  'Microphoneline',
  'Microphonesolid',
  'More',
  'Move',
  'Muteline',
  'Mutesolid',
  'Nextline',
  'Nextsolid',
  'Nowifiline',
  'Nowifisolid',
  'Openlockline',
  'Openlocksolid',
  'Pauseline',
  'Pausesolid',
  'Playline',
  'Playsolid',
  'Plus',
  'Previousline',
  'Previoussolid',
  'Questionline',
  'Questionsolid',
  'View-queue',
  'Radiobuttonfilled',
  'Radiobuttonline',
  'Removecircleline',
  'Removecirclesolid',
  'Replayline',
  'Replaysolid',
  'Searchline',
  'Searchsolid',
  'Seriesline',
  'Seriessolid',
  'Settingsline',
  'Settingssolid',
  'Shoppingcartline',
  'Shoppingcartsolid',
  'Sortbyline',
  'Sortbysolid',
  'Soul',
  'Sounds',
  'SoundCloudline',
  'SoundCloudsolid',
  'Speaker',
  'Starline',
  'Starsolid',
  'Stopline',
  'Stopsolid',
  'Stopcircleline',
  'Stopcirclesolid',
  'Story',
  'Tag',
  'Teaser',
  'TikTokline',
  'TikToksolid',
  'Trash-can-line',
  'Twitterline',
  'Twittersolid',
  'Unfollowspeaker',
  'Unlockedlockline',
  'Unlockedlocksolid',
  'Userline',
  'Usersolid',
  'Volumeline',
  'Volumesolid',
  'Warningline',
  'Wifiline',
  'Wifisolid',
  'YouTubeline',
  'YouTubesolid',
] as const;

export type FemtasyIcon = typeof femtasyIconNames[number];
